import Component from '@cell/cell-core/component/component';
import { debounce } from '@cell/cell-core/utils';
import './search.scss';

class Search extends Component {
  constructor() {
    super();

    this.elements = {
      results: this.querySelector('.Search__Results'),
    };
  }

  componentDidMount() {
    this.on('c-input.input', debounce(this.handleInput.bind(this)));
    this.on('c-input.reset', this.handleInput.bind(this));
  }

  handleInput(event) {
    // TODO: We should probably remove all `%` characters from the query since they seem to cause
    // errors when fetching. Alternatively, we could encode the query.
    const searchTerm = event.data.value.trim();

    if (searchTerm.length === 0) {
      this.elements.results.innerHTML = '';
      this.elements.results.removeAttribute('data-active');

      return;
    }

    this.getSearchResults(searchTerm);
  }

  async getSearchResults(searchTerm) {
    const res = await fetch(
      `${window.Shopify.routes.root}search?q=${searchTerm}&section_id=search-results`,
    );
    const html = await res.text();

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    this.elements.results.innerHTML = doc.querySelector('.shopify-section').innerHTML;
    this.elements.results.setAttribute('data-active', 'true');
  }
}

customElements.define('c-search', Search);
